import React, { Component } from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'

import Navbar from './Navbar'
import Home from './Home'
import Complete from './Complete'
import DeploymentRequest from './DeploymentRequest'
import NotFound from './NotFound'

class App extends Component {
  render() {
    return (
      <Router>
        <div>
          <Switch>
            <Route exact path="/" component={Home} />
            <Route path="/complete" component={Complete} />
            <Route path="/deployment-request" component={DeploymentRequest} />
            <Route component={NotFound} />
          </Switch>
        </div>
      </Router>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js